import { makeStyles } from "@mui/styles";

export const popupContainer = {
  background: "#fff",
  maxWidth: "1100px",
  "overflow-x": "hidden",
};
export const closeBtnStyle = {
  color: "#000",
};
export const useProductsStyles = makeStyles(() => {
  return {
    modalHeader: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      "&.modalHeaderMargin": {
        marginTop: "5%",
      },
      "&.mobile": {
        marginTop: "10%",
      },
    },
    planTitle: {
      color: "#0275C4",
      fontSize: "42px !important",

      "&.planTitleLandingPage": {
        fontFamily: "Lato ",
        fontSize: "32px !important",
        fontWeight: "700",
        lineHeight: "36px",
        textAlign: "center",
        color: "#1976D2",
      },
    },
    planSubTitle: {
      fontSize: "24px !important",

      "&.planSubTitleLandingPage": {
        fontFamily: "Lato ",
        fontSize: "28px !important",
        fontWeight: "300",
        lineHeight: "36px",
        textAlign: "center",
        color: "#1976D2",
      },
    },
    listItemContent: {
      textAlign: "center",
      margin: "10px 20px",
      paddingTop: "20px",
      borderTop: "3px solid #0596FB",
      "&.threeMonths": {
        borderTop: "3px solid #0275C4",
      },
      "&.oneYear": {
        borderTop: "3px solid #FF6C37",
      },
      "&.autoPay": {
        borderTop: "3px solid #333333",
      },
    },
    card: {
      "&:hover": {
        height: "405px",
        width: "280px !important",
        zIndex: "22",
        marginTop: "-20px",
        boxShadow: " 0px 1px 4px 0px rgba(0, 0, 0, 0.25)",
        transition: "boxShadow 0.3s",
        "&.changeWidth": {
          width: "calc(100% + 10px) !important",
          height: "365px !important",
        },
      },
    },
    cardTitle: {
      color: "#FFF",
      background: "#0596FB",
      height: "50px",
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      "&.threeMonths": {
        background: "#0275C4",
      },
      "&.oneYear": {
        background: "#FF6C37",
      },
      "&.autoPay": {
        background: "#333333",
      },
    },
    cardSubtitle: {
      fontSize: "32px !important",
      color: "#0596FB",
      "&.threeMonths": {
        color: "#0275C4",
      },
      "&.oneYear": {
        color: "#FF6C37",
      },
      "&.autoPay": {
        color: "#333333",
      },
      "&.subTitleMargin": {
        marginTop: "25px",
      },
    },
    content: {
      height: "375px",
      padding: "0px !important",
      "&.changeWidth": {
        height: "325px",
      },
    },
    productContainer: {
      marginTop: "20px",
      "&.productGridHeight": {
        height: "405px",
      },
    },

    bestSeller: {
      color: "#FF6C37",
      textTransform: "uppercase",
      letterSpacing: "5px !important",
    },
    bestSellerInside: {
      color: "black !important",
    },
    description: {
      flexDirection: "column",
      justifyContent: "center",
      textAlign: "center",
      border: "1px solid grey",
      height: "inherit",
      width: "inherit",
      borderRadius: "4px",
      position: "relative",
      transition: "height 0.3s, width 0.3s",
      "& h3, h5": {
        margin: "0px",
      },
    },
    alertBox: {
      display: "flex",
      justifyContent: "center",
      marginTop: "10px",
    },
    footer: {
      justifyContent: "center",
      position: "absolute",
      right: "0px",
      left: "0px",
      bottom: "30px",
      transition: "bottom 0.3s",
    },
    buyBtn: {
      background: "linear-gradient(98deg, #0b3450 0%, #1a669b 100%) !important",
      "&.oneYear": {
        background:
          "linear-gradient(90deg, #FF5D22 0%, #FB8C64 100%) !important",
      },
      "&.autoPay": {},
    },
    info: {
      position: "absolute",
      fontSize: "12px !important",
      color: "#707070 !important",
      bottom: "-18px",
    },
    monthlyText: {
      marginTop: "-10px !important",
    },
    scanQrTitle: {
      color: "#fff",
      fontSize: "20px !important",
    },
    qrCodeImg: {
      display: "flex",
      justifyContent: "center",
      marginTop: "15px",
    },
  };
});
